import React from 'react';
import { Panel } from 'primereact/panel';
import DataTable from '../../../shared/component/dataTable/DataTable';
import MobileColumn from '../../../shared/component/dataTable/columns/MobileColumn.json';
import Dialog from '../../../shared/component/dialog/Dialog';
import Translate from "../../../shared/language/Translate";
import { Button } from 'reactstrap';
import { PAGE_MODE } from "../../../shared/utils/Constants";
import Toolbar from "../../../shared/component/toolbar/Toolbar";
import GeneralUtils from "../../../shared/utils/GeneralUtils";
import * as XLSX from "xlsx";
import { toast } from "react-toastify";
import RequestAssetService from "../../../shared/service/RequestAssetService";
import Mobile from './Mobile';
import MobileService from '../../../shared/service/MobileService';


const fileError = {
    CHECK_UPLOAD_FILE: "CHECK_UPLOAD_FILE",
    FILL_ALL_ELEMENT: "FILL_ALL_ELEMENT",
}

export default class MobileList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            excelData: [],
            pageMode: null,
            displayDialogForExcel: false
        };
        this.service = new MobileService();
        this.requestAssetService = new RequestAssetService();

    }

    componentDidMount = () => {
        this.service.checkPage();
    }

    componentDidMount = () => {
        let contactId = GeneralUtils.getContactId();
                this.refDataTable.setParameter( contactId);
        
    }

    render() {
        return (
            <Panel header="Mobil Yönetimi">
                <Toolbar display={true} >
                    <div className="p-toolbar-group-right">
                        <Button color="primary" onClick={this.addNew}>
                            <Translate contentKey="entity.action.add">Yeni Kayıt</Translate>
                        </Button>
                    </div>
                </Toolbar>
                <DataTable ref={(elem) => this.refDataTable = elem} fields={MobileColumn.fields} dataURL="mobile/findAll"
                    objectName={MobileColumn.name}
                    selectionMode="single" onDataSelect={this.onDataSelect} loading={this.state.loading} export={true} autoLoad={false} />
                <Dialog visible={this.state.displayDialog}
                    header={GeneralUtils.getDialogHeader('Varlık', this.state.pageMode)}
                    onHide={() => this.setState({ displayDialog: false })} style={{ width: '50vw' }}>
                    <Mobile ref={(elem) => this.refMobile = elem}
                        closeDisplayDialog={this.closeDisplayDialog} refresh={this.refresh} />
                </Dialog>
            </Panel>
        );
    }

    refresh = () => {
        this.refDataTable.refresh();
    }

    onDataSelect = (data) => {
        let pageMode = GeneralUtils.getPageModeFromPrivilege(MobileColumn.name);
        this.setState({ displayDialog: true, pageMode: pageMode });
        this.refMobile.setData(data, pageMode);
    }

    addNew = () => {
        this.setState({ displayDialog: true, pageMode: PAGE_MODE.CREATE });
        this.refMobile.addNew();
    }

    closeDisplayDialog = () => {
        this.setState({ displayDialog: false });
    }

    clearDataExcel = () => {
        this.setState({ excelData: [], organization: '', displayRegions: false });
    }

    saveForExcel = () => {

        if (GeneralUtils.__isValueEmpty(this.refFile.value)) {
            return toast.warn('Lütfen dosya yükleyiniz.');
        }


        this.setState({ loading: true });

        let data = this.state.excelData.map((element) => GeneralUtils.addCreateInfo(element));

        this.requestAssetService.createForExcel(data, 'this.state.requestType', 'this.state.requestId', this.state.inventoryOrganizationCode).then(response => {
            if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {

                let errorCheckCount = 0;
                response.forEach(element => {
                    if (element.hasError) {
                        errorCheckCount++;
                    }
                })

                if (errorCheckCount != 0) {
                    this.setState({ loading: false, excelData: response });
                    return toast.warn('Lütfen hatalı kayıtları düzelterek kaydedin.');
                }

                toast.success("İşlem başarıyla gerçekleştirilmiştir.");
                this.setState({ loading: false, displayDialogForExcel: false });

            }
        }
        );
    }


    onImportExcel = (file) => {
        let { files } = file.target;
        if (GeneralUtils.isNullOrEmpty(files)) {
            return;
        }
        let fileReader = new FileReader();
        fileReader.onload = event => {
            try {
                let { result } = event.target;
                let workbook = XLSX.read(result, { type: 'binary' });
                let data = [];
                for (let sheet in workbook.Sheets) {
                    if (workbook.Sheets.hasOwnProperty(sheet)) {
                        data = data.concat(XLSX.utils.sheet_to_json(workbook.Sheets[sheet]));
                    }
                }

                let newDataArray = this.getNewDataArray(data);

                if (newDataArray.length == 0) {
                    this.deleteSelectedFile();
                    return toast.warn('Dosyada kayıt bulunamadı.');
                }

                this.setState({ loading: true });
                this.requestAssetService.checkForExcel(newDataArray, this.state.inventoryOrganizationCode).then(response => {
                    if (!GeneralUtils.isNullOrEmpty(response)) {
                        this.setState({
                            excelData: response,
                            loading: false,
                            displayRegions: true
                        });
                    }
                });
            } catch (e) {
                console.log(e);
                let errorMessage = "";
                if (e === fileError['CHECK_UPLOAD_FILE']) {
                    errorMessage = "Lütfen seçilen dosyayı kontrol ediniz.";
                } else if (e === fileError['FILL_ALL_ELEMENT']) {
                    errorMessage = "Lütfen her bir envanter için tüm alanların dolu olduğudan emin olunuz.";
                }
                this.setState({
                    loading: false, excelData: []
                });
                this.deleteSelectedFile();
                return toast.warn(errorMessage);
            }
        };
        // Open the file in binary mode
        fileReader.readAsBinaryString(files[0]);
    }


    ExcelDateToJSDate = (serial) => {
        let utc_days = Math.floor(serial - 25569);
        let utc_value = utc_days * 86400;
        let date_info = new Date(utc_value * 1000);
        let fractional_day = serial - Math.floor(serial) + 0.0000001;
        let total_seconds = Math.floor(86400 * fractional_day);
        let seconds = total_seconds % 60;
        total_seconds -= seconds;
        let hours = Math.floor(total_seconds / (60 * 60));
        let minutes = Math.floor(total_seconds / 60) % 60;

        return new Date(date_info.getFullYear(), date_info.getMonth(), date_info.getDate(), hours, minutes, seconds);
    }

    getNewDataArray = (data) => {
        let newDataArray = [];
        data.map(element => {
            let newData = {
                username: "",
                keyword: "",
                cityId: {
                    name: ""
                },
                districtId: {
                    name: ""
                },
                phone: "",
                ssidName: "",
                password: "",
                wanIp: "",
                routerSerialNo: "",
                routerMacAddress: "",
                createdBy: GeneralUtils.getUserId()
            }
            newData.username = element['KULLANICI ADI'];
            newData.keyword = element['PAROLA'];
            newData.cityId.name = element['İL'];
            newData.districtId.name = element['İLÇE'];
            newData.phone = element['TELEFON'];
            newData.ssidName = element['SSID ADI'];
            newData.password = element['ŞİFRE'];
            newData.wanIp = element['WAN IP'];
            newData.routerSerialNo = element['ROUTER SERİ NO'];
            newData.routerMacAddress = element['ROUTER MAC ADRESİ']
            this.checkFile(newData);
            newDataArray.push(newData);
            return element;
        });

        return newDataArray;
    }

    checkFile = (data) => {
        if (data.organizationId.code === undefined &&
            data.locationId.code === undefined &&
            data.floorId.name === undefined &&
            data.roomId.name === undefined &&
            data.brandId.name === undefined &&
            data.modelId.name === undefined &&
            data.assetTag === undefined &&
            data.serialNumber === undefined &&
            data.dateOfLive === undefined &&
            data.macAddress === undefined &&
            data.nature === undefined &&
            data.assetType === undefined &&
            data.temosId === undefined &&
            data.acceptanceDate === undefined &&
            data.activatedDate === undefined &&
            data.hsmProjectId.name === undefined &&
            data.createdBy === undefined
        ) {
            throw 'CHECK_UPLOAD_FILE';
        } else if (data.organizationId.code === undefined ||
            data.locationId.code === undefined ||
            data.floorId.name === undefined ||
            data.roomId.name === undefined ||
            data.brandId.name === undefined ||
            data.modelId.name === undefined ||
            data.assetTag === undefined ||
            data.serialNumber === undefined ||
            data.dateOfLive === undefined ||
            data.macAddress === undefined ||
            data.nature === undefined ||
            data.assetType === undefined ||
            data.temosId === undefined ||
            data.acceptanceDate === undefined ||
            data.activatedDate === undefined ||
            data.hsmProjectId.name === undefined ||
            data.createdBy === undefined
        ) {
            throw 'FILL_ALL_ELEMENT';
        }
    }

    downloadTaskExcel = () => {
        let url = 'data/taskExcel.xlsx'
        let a = document.createElement('a')
        a.href = url
        a.download = 'taskExcel.xlsx'
        a.click()
        window.URL.revokeObjectURL(url)
    }

    deleteSelectedFile = () => {
        this.refFile.value = null;
    }
}
